module.exports = __webpack_public_path__ + "img/horizontal_2_1_r_5012.3a7fd943.png";